import { DataPackageV2Component } from '@vivli/shared/features/data-package/components';

interface AttachmentsDataPackageViewFeatureProps {
    dataPackageId: string;
    allowUpload: boolean;
}

export const AttachmentsDataPackageFeature = ({ dataPackageId, allowUpload }: AttachmentsDataPackageViewFeatureProps) => (
    <DataPackageV2Component
        dataPackageId={dataPackageId}
        readOnly={true}
        allowDownload={true}
        allowUpload={allowUpload}
        allowDelete={false}
        allowSubmit={false}
        showFileType={false}
        availableTypes={['Research Proposal Supplement', 'Funding Information', 'Statistical Analysis Plan', 'Other', 'Unknown']}
        title={'UPLOADED FILES'}
    />
);
